import { useQuery } from "@tanstack/react-query";
import {
  getMerchantsAppProducts,
  getMerchantsPublicIDAppProducts,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const MERCHANT_APP_PRODUCTS_QUERY_KEY = "MERCHANT_APP_PRODUCTS";

export const merchantAppProductsKeys = {
  all: [MERCHANT_APP_PRODUCTS_QUERY_KEY],
  byMerchantPublicId: (merchantPublicID?: string) => [
    ...merchantAppProductsKeys.all,
    merchantPublicID,
  ],
};

export const useGetMerchantAppProductsQuery = (merchantPublicID?: string) =>
  useQuery({
    queryKey: merchantAppProductsKeys.byMerchantPublicId(merchantPublicID),
    queryFn: processResponseWithApiProblemDetails(() =>
      merchantPublicID
        ? getMerchantsPublicIDAppProducts(merchantPublicID)
        : getMerchantsAppProducts(),
    ),
  });
